function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import React, { useCallback, useMemo, useState } from "react";
import cx from "classnames";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { useResizeObserverRef } from "rooks";
import { Body } from "../Body";
import { twMerge } from "../../../utils";
export function FilterSelector(param) {
    var name = param.name, label = param.label, value = param.value, options = param.options, onChange = param.onChange, className = param.className;
    var ref = _slicedToArray(useState(0), 2), triggerWidth = ref[0], setTriggerWidth = ref[1];
    var ref1 = _slicedToArray(useState(0), 2), contentWidth = ref1[0], setContentWidth = ref1[1];
    var minWidth = Math.max(triggerWidth, contentWidth);
    var ref2 = _slicedToArray(useResizeObserverRef(useCallback(function(entries) {
        if (entries.length) {
            var ref;
            var target = (ref = entries[0]) === null || ref === void 0 ? void 0 : ref.target;
            var ref1;
            var offsetWidth = (ref1 = target === null || target === void 0 ? void 0 : target.offsetWidth) !== null && ref1 !== void 0 ? ref1 : 0;
            var width = Math.ceil(offsetWidth);
            setTriggerWidth(width);
        }
    }, [])), 1), triggerResizeObserverRef = ref2[0];
    var ref3 = _slicedToArray(useResizeObserverRef(useCallback(function(entries) {
        if (entries.length) {
            var ref;
            var target = (ref = entries[0]) === null || ref === void 0 ? void 0 : ref.target;
            var ref1;
            var offsetWidth = (ref1 = target === null || target === void 0 ? void 0 : target.offsetWidth) !== null && ref1 !== void 0 ? ref1 : 0;
            var width = Math.ceil(offsetWidth);
            setContentWidth(width);
        }
    }, [])), 1), contentResizeObserverRef = ref3[0];
    var triggerLabel = useMemo(function() {
        if ((value === null || value === void 0 ? void 0 : value.length) === 1) {
            var ref;
            var ref1;
            return (ref1 = (ref = options.find(function(opt) {
                return opt.value === value[0];
            })) === null || ref === void 0 ? void 0 : ref.label) !== null && ref1 !== void 0 ? ref1 : label;
        }
        if (value === null || value === void 0 ? void 0 : value.length) {
            var ref2;
            var length = value.length;
            var ref3;
            return "".concat((ref3 = (ref2 = options.find(function(opt) {
                return opt.value === value[0];
            })) === null || ref2 === void 0 ? void 0 : ref2.label) !== null && ref3 !== void 0 ? ref3 : label, " (+").concat(length - 1, ")");
        }
        return label;
    }, [
        value,
        options,
        label
    ]);
    var handleCheckedChange = useCallback(function(option, state) {
        var valueArr = value || [];
        var currentIndex = valueArr.indexOf(option.value);
        if (state === true && currentIndex === -1) {
            onChange(name, _toConsumableArray(valueArr).concat([
                option.value
            ]));
        } else if (state === false && currentIndex > -1) {
            var next = _toConsumableArray(valueArr);
            next.splice(currentIndex, 1);
            onChange(name, next);
        }
    }, [
        name,
        value,
        onChange
    ]);
    var internalOptions = useMemo(function() {
        var valueArr = value || [];
        return options.map(function(opt) {
            return _objectSpreadProps(_objectSpread({}, opt), {
                $internal: {
                    checked: valueArr.includes(opt.value),
                    onCheckedChange: function(state) {
                        return handleCheckedChange(opt, state);
                    }
                }
            });
        });
    }, [
        options,
        value,
        handleCheckedChange
    ]);
    return /*#__PURE__*/ React.createElement(DropdownMenu.Root, null, /*#__PURE__*/ React.createElement(DropdownMenu.Trigger, {
        className: twMerge(cx("bg-bg-default border border-fg-default", '[&[data-state="open"]]:border-transparent [&[data-state="open"]>svg]:rotate-90', className))
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            minWidth: "".concat(minWidth, "px")
        }
    }, /*#__PURE__*/ React.createElement("div", {
        ref: triggerResizeObserverRef
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center px-6 py-4"
    }, /*#__PURE__*/ React.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        className: "shrink-0 text-brand-primary-base transition-all"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M9.00003 6L15.1177 12.1176L9.00003 18.2353",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    })), /*#__PURE__*/ React.createElement(Body, {
        className: "ml-3 text-left"
    }, triggerLabel))))), /*#__PURE__*/ React.createElement(DropdownMenu.Portal, null, /*#__PURE__*/ React.createElement(DropdownMenu.Content, {
        avoidCollisions: false,
        side: "bottom",
        className: "isolate grid grid-cols-1 grid-rows-1 z-10 bg-bg-default"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "col-start-1 row-start-1 mt-[-3.0625rem] outline outline-1 outline-fg-default"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "col-start-1 row-start-1",
        style: {
            minWidth: "".concat(minWidth, "px")
        }
    }, /*#__PURE__*/ React.createElement("div", {
        ref: contentResizeObserverRef
    }, internalOptions.map(function(option) {
        return /*#__PURE__*/ React.createElement(DropdownMenu.CheckboxItem, {
            key: option.value,
            className: 'px-6 py-4 cursor-pointer [&[data-state="checked"]]:text-brand-primary-base [&[data-state="checked"]]:bg-fg-inverted',
            checked: option.$internal.checked,
            onCheckedChange: option.$internal.onCheckedChange
        }, option.label);
    }))))));
}

//# sourceMappingURL=FilterSelector.js.map